import { useEffect } from 'react';

/**
 * Meta Pixel base code — Court Ready.
 * Single source of truth for the pixel id: this is the only place it is
 * initialised. Guards (module flag + window flag + existing fbq) make sure
 * `init` and `PageView` fire exactly once per page load, even under
 * React re-mounts or hot reloads.
 */
const PIXEL_ID = '1584014326242960';
type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: Fbq;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
    __metaPixelInitialized?: string;
  }
}
let initialized = false;
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || !PIXEL_ID) return;
    if (initialized || window.__metaPixelInitialized === PIXEL_ID) return;
    initialized = true;
    window.__metaPixelInitialized = PIXEL_ID;
    if (!window.fbq) {
      const fbq = function (...args: unknown[]) {
        if (fbq.callMethod) fbq.callMethod(...args);else fbq.queue.push(args);
      } as Fbq;
      fbq.queue = [];
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      window.fbq = fbq;
      if (!window._fbq) window._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return null;
}